import styled from 'styled-components';

export const Container = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 24px;
  min-height: 100vh;
  background: #f5f5f5;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

export const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
`;

export const PasswordContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 24px;
  background: #f5f5f5;
`;

export const PasswordBox = styled.div`
  background: white;
  padding: 32px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
`;

export const PasswordTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 24px 0;
  text-align: center;
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 16px;
  margin-bottom: 16px;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #000;
  }
`;

export const Button = styled.button<{ variant?: 'primary' | 'secondary' }>`
  padding: 12px 24px;
  background: ${props => props.variant === 'secondary' ? '#f0f0f0' : '#000'};
  color: ${props => props.variant === 'secondary' ? '#333' : '#fff'};
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: ${props => props.variant === 'secondary' ? '#e0e0e0' : '#333'};
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

export const ConversationList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ConversationCard = styled.div<{ selected?: boolean }>`
  background: ${props => props.selected ? '#e8f4f8' : 'white'};
  border: 1px solid ${props => props.selected ? '#0ea5e9' : '#e0e0e0'};
  border-radius: 12px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: #0ea5e9;
  }
`;

export const ConversationHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
`;

export const BusinessName = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
`;

export const LastMessageTime = styled.span`
  font-size: 12px;
  color: #666;
`;

export const LastMessage = styled.p`
  font-size: 14px;
  color: #666;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const MessagesContainer = styled.div`
  background: white;
  border-radius: 12px;
  margin-top: 16px;
  overflow: hidden;
`;

export const MessagesHeader = styled.div`
  padding: 16px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const MessagesList = styled.div`
  padding: 16px;
  max-height: 400px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const MessageBubble = styled.div<{ isAdmin?: boolean }>`
  max-width: 80%;
  padding: 12px 16px;
  border-radius: 16px;
  align-self: ${props => props.isAdmin ? 'flex-end' : 'flex-start'};
  background: ${props => props.isAdmin ? '#0ea5e9' : '#f0f0f0'};
  color: ${props => props.isAdmin ? '#fff' : '#1a1a1a'};
`;

export const MessageText = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
`;

export const MessageMeta = styled.div<{ isAdmin?: boolean }>`
  font-size: 11px;
  color: ${props => props.isAdmin ? 'rgba(255,255,255,0.7)' : '#666'};
  margin-top: 4px;
  text-align: ${props => props.isAdmin ? 'right' : 'left'};
`;

export const ReplyContainer = styled.div`
  padding: 16px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  gap: 12px;
`;

export const ReplyInput = styled.textarea`
  flex: 1;
  padding: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  resize: none;
  min-height: 60px;
  font-family: inherit;

  &:focus {
    outline: none;
    border-color: #0ea5e9;
  }
`;

export const ErrorText = styled.p`
  color: #dc2626;
  font-size: 14px;
  margin: 8px 0 0 0;
  text-align: center;
`;

export const LoadingText = styled.p`
  color: #666;
  font-size: 14px;
  text-align: center;
  padding: 24px;
`;

export const EmptyText = styled.p`
  color: #666;
  font-size: 14px;
  text-align: center;
  padding: 48px 24px;
`;

export const RefreshButton = styled.button`
  background: none;
  border: none;
  color: #0ea5e9;
  font-size: 14px;
  cursor: pointer;
  padding: 4px 8px;

  &:hover {
    text-decoration: underline;
  }
`;
